<template>
  <div class="checkbox__wrapper">
    <input class="checkbox__input" type="checkbox" />

    <label
      ref="width"
      class="checkbox__label"
      :class="{
        'checkbox__label--checked': input,
      }"
    >
      <div class="checkbox__border" @click.prevent="input = !input">
        <div class="checkbox__border-inner" />
        <div class="checkbox__image" />
      </div>

      <div class="checkbox__text">
        <span>{{ text }}</span>

        <slot name="link" />

        <span>{{ text2 }}</span>

        <slot name="link2" />
      </div>
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'Checkbox',

  emits: ['update:modelValue'],

  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: null,
    },
    text: {
      type: [String, null],
      required: false,
      default: null,
    },
    text2: {
      type: [String, null],
      required: false,
      default: null,
    },
  },

  setup(props, { emit }) {
    const input = computed({
      get: () => props.modelValue,
      set: (value: boolean) => {
        emit('update:modelValue', value);
      },
    });

    return {
      input,
    };
  },
});
</script>

<style lang="stylus" scoped>
@import "~/src/assets/stylus/main.styl";

$name = ".checkbox"

{$name}
  position relative

  &__wrapper
    @extend $check__wrapper

  &__input
    @extend $check__input

  &__image
    @extend $check__image

  &__border
    @extend $check__border

  &__border-inner
    @extend $check__border-inner

  &__label
    @extend $check__label

  &__text
    @extend $check__text
</style>
